import { CheckCircle, XCircle } from '@chain-zen/ui'
import React from 'react'

interface VerificationStatusProps {
  height?: number
  isVerified: boolean
  width?: number
}

export const VerificationStatus = (props: VerificationStatusProps) => {
  const { isVerified = false, width = 4, height = 4 } = props

  return (
    <div>
      {isVerified ? (
        <CheckCircle className="text-green-500" style={{ height: `${height}px`, width: `${width}px` }} />
      ) : (
        <XCircle className="text-gray-400" style={{ height: `${height}px`, width: `${width}px` }} />
      )}
    </div>
  )
}
